import './style';
import { Provider } from 'unistore/preact';
import { Router } from 'preact-router';
import { trackPageview } from 'utils/analytics';

import store from 'state/store';
import Home from 'routes/home';
import Map from 'routes/map';
import SubmitData from 'routes/submitData';
import AboutTheData from 'routes/aboutTheData';
import Contact from 'routes/contact';

if (module.hot) {
	require('preact/debug');
}

const updatePage = () => {
	if (typeof document !== 'undefined') {
		const main = document.getElementById('main');
		if (main) {
			main.scrollTop = 0;
		}

		trackPageview();

		const menu = document.getElementById('menu');
		if (menu) {
			menu.checked = false;
		}
	}
};

const isUCBrowser = () => {
	if (typeof document !== 'undefined') {
		return navigator.userAgent.includes('SamsungBrowser')
			? 'samsung-browser'
			: '';
	}
	return '';
};

export default () => (
	<div className={isUCBrowser()}>
		<Provider store={store}>
			<Router onChange={updatePage}>
				<Home path="/" />
				<SubmitData path="/submit-data" key={'submit'} />
				<Map path="/explore-map" key={'map'} />
				<AboutTheData path="/about-the-data" key="about" />
				<Contact path="/contact" />
			</Router>
		</Provider>
	</div>
);



// WEBPACK FOOTER //
// ./index.js